// extracted by mini-css-extract-plugin
export var section = "_50-1";
export var topNav = "_50-0";